<template>
  <div class="loading">
    <div class="loading-holder">
      <img src="https://wro-v.com/img/logo.8b1d73b8.svg" width="120" v-if="checkPath">
      <q-spinner
          color="primary"
          size="3em"
      />
    </div>
  </div>
</template>

<script>

export default {
  data:() => ({
    checkPath: true,
  }),
  mounted() {
    if(this.$route.path == '/'){
      this.checkPath =  true;
    }else{
      this.checkPath =  false;
    }
  }
}

</script>

<style scoped>
.loading{
  position: relative;
  left: 0;
  top: 0;
  width: 100%;
  z-index: 55;
  height: 100vh;
  background: #fff;
}

.loading-holder {
  display: flex;
  justify-content: center;
  align-items: center;
  align-content: center;
  flex-direction: column;
  height: 100vh;
}

.loading img{
  position: relative;
  left: -10px;
  margin-bottom: 10px;
}

.headers .loading {
  height: 17vh;
}


</style>